import Modal from '../../components/common/callback/modal/modal';
import { useGlobalContext } from '../../context/globalContext';


export function BlockedModal() {
  const { showBlockedModal, setShowBlockedModal, errorMessage } = useGlobalContext();

  const closeModal = () => {
    setShowBlockedModal(false);
  };

  return (
    <Modal
      type={'blockedError'}
      shown={showBlockedModal}
      close={closeModal}
      error={errorMessage}
    />
  );
}
